import AbstractHandler from '@/language/handlers/AbstractHandler';
import Language from '@/language/Language';
import router from '@/router';
import Handler from '@/language/handlers/Handler';
import { VueRouter } from 'vue-router/types/router';

export default class LocalizedRouteHandler extends AbstractHandler {
    private router: VueRouter;

    constructor(nextHandler?: Handler) {
        super(nextHandler);

        this.router = router;
    }

    handle(language: Language): void {
        const to = this.router.resolve({
            params: {
                locale: language.code,
            },
        });

        this.router.push(to.location);

        super.handle(language);
    }
}
